import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { DefaultModal } from "../../../../common/modals/default-modal/default-modal";
import { resources } from "@constants/hardcoded-strings";
import {
    FormattedVerificationTransactionDetailsScore,
    FormattedVerificationTransactionDetailsTrustScoreBreakdown,
    FormattedVerificationTransactionDetailsTrustScoreInput,
    FormattedVerificationTransactionDetailsTrustScoreModifier,
    FormattedVerificationTransactionDetailsAssertionScoreBreakdown,
    FormattedVerificationTransactionDetailsAssertionScoreModifier
} from "@idw-types/data/verification-transaction-details";
import { VerificationTransactionScoreTypes } from "@enums/verification-transaction-score-types";
import { CardContainer } from "../../../../common/card-container/card-container";
import { ContentPageBody } from "../../../../common/content-page-body/content-page-body";
import { ContentPageHeader } from "../../../../common/content-page-header/content-page-header";
import { TrustScoreModifiersTableContainer } from "./trust-score-modifiers-table-container/trust-score-modifiers-table-container";
import { TrustScoreInputsTableContainer } from "./trust-score-inputs-table-container/trust-score-inputs-table-container";
import { isStringTrue } from "@iddataweb/idw-common-ui/utils";
import styles from "./verification-transaction-details-scores-modal.less";

type VerificationTransactionDetailsScoresModalProps = {
    onModalClose: () => void;
    scores: Array<FormattedVerificationTransactionDetailsScore>;
    trustScoreBreakdown: FormattedVerificationTransactionDetailsTrustScoreBreakdown;
    trustScoreInputs: Array<FormattedVerificationTransactionDetailsTrustScoreInput>;
    trustScoreModifiers: Array<FormattedVerificationTransactionDetailsTrustScoreModifier>;
    assertionScoreBreakdowns: Array<FormattedVerificationTransactionDetailsAssertionScoreBreakdown>;
    assertionScoreModifiers: Array<FormattedVerificationTransactionDetailsAssertionScoreModifier>;
};

export const VerificationTransactionDetailsScoresModal = (props: VerificationTransactionDetailsScoresModalProps) => {
    const {
        onModalClose,
        scores,
        trustScoreBreakdown,
        trustScoreInputs,
        trustScoreModifiers,
        assertionScoreBreakdowns,
        assertionScoreModifiers
    } = props;

    const idwScore = scores.find(score => score.scoreType === VerificationTransactionScoreTypes.IDW_RISK_SCORE);

    const relatedAssertionScoreBreakdown = assertionScoreBreakdowns.find(asb => {
        const assertionScore = scores.find(s => s.id === asb.userAcquiredScoreHistoryID);

        if (assertionScore) {
            return (
                asb.apiKey === trustScoreBreakdown?.apiKey
                //&& score.attempt === attempt //todo - need to figure out what this does
                // it was present in the old application but was always undefined
            );
        }
        return false;
    });

    const relatedAssertionScoreModifiers = relatedAssertionScoreBreakdown ? assertionScoreModifiers.filter(asm => {
        return (
            (asm.maxPotentialScore !== 0 || asm.claimAssertionScore !== 0) &&
            isStringTrue(asm.wasApplied) &&
            asm.assertionScoreBreakdownID === relatedAssertionScoreBreakdown?.id
        );
    }) : [];

    return (
        <DefaultModal
            automationId={`verification-transaction-details-scores-modal`}
            ariaLabelledBy={`verification-transaction-details-scores-modal-title`}
            onHide={onModalClose}
            keyboard={false}
            isMaxWidth={true}
        >
            <Modal.Header id={`verification-transaction-details-scores-modal-title`} closeButton>
                <Modal.Title className={styles.verificationTransactionDetailsScoresModalTitle}>
                        {resources.modals.verificationTransactionDetailsScores.title}
                        <span className={styles.points}>{resources.modals.verificationTransactionDetailsScores.trustScorePoints(idwScore.score)}</span>
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <CardContainer>
                    <ContentPageHeader title={resources.tables.verificationTransactionDetailsScoreComponents.title} />
                    <ContentPageBody isMaxWidth={true}>
                        <TrustScoreInputsTableContainer
                            trustScoreInputs={trustScoreInputs}
                            assertionScoreBreakdown={relatedAssertionScoreBreakdown}
                            assertionScoreModifiers={relatedAssertionScoreModifiers}
                        />
                    </ContentPageBody>
                </CardContainer>
                <CardContainer>
                    <ContentPageHeader title={resources.tables.verificationTransactionDetailsTrustScoreModifiers.title} />
                    <ContentPageBody isMaxWidth={true}>
                        <TrustScoreModifiersTableContainer trustScoreModifiers={trustScoreModifiers} />
                    </ContentPageBody>
                </CardContainer>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={onModalClose}>{resources.common.buttons.close.label}</Button>
            </Modal.Footer>
        </DefaultModal>
    );
};